import { Attr, HasMany, HasOne, Model } from "spraypaint";

import SourceRecord from "shared/resources/SourceRecord";

import type Category from "./Category";
import type CopyrightAgency from "./CopyrightAgency";
import type Outlet from "./Outlet";
import type SourceGroup from "./SourceGroup";
import type SourceTopic from "./SourceTopic";
import type WebsiteDomain from "./WebsiteDomain";

@Model()
class Website extends SourceRecord {
  static jsonapiType = "websites";

  @Attr() aliases: string[];

  @Attr({ persist: false }) archivedAt: string;

  @Attr() caldContent: boolean;

  @HasOne() category: Category;

  @Attr() categoryId: number;

  @HasOne() copyrightAgency: CopyrightAgency;

  @Attr() copyrightAgencyId: number;

  @Attr({ persist: false }) createdAt: string;

  @Attr() dailyAudience: number;

  @Attr() domain: string;

  @Attr() label: string;

  @Attr() lastArticleAt: string;

  @Attr() locationId: number;

  @Attr() logoData: string;

  @Attr({ persist: false }) medium: string;

  @Attr() monthlyAudience: number;

  @Attr() notes: string;

  @Attr() origin: string;

  @HasOne() outlet: Outlet;

  @Attr() outletId: number;

  @Attr() paywall: string;

  @Attr() plainTextPaywallBypass: boolean;

  @Attr() satirical: boolean;

  @Attr() scraper: string;

  @Attr() scrapingCookie: string;

  @HasOne() sourceGroup: SourceGroup;

  @Attr() sourceGroupId: number;

  @Attr() syndication: string;

  @Attr() tier: number;

  @HasMany() topics: SourceTopic[];

  @Attr() translate: boolean;

  @Attr({ persist: false }) updatedAt: string;

  @Attr() useProxy: boolean;

  @Attr() visible: boolean;

  @HasMany() websiteDomains: WebsiteDomain[];

  internationalPlus() {
    return this.origin === "aylien";
  }
}

export default Website;
